<template>
    <div>
        <b-row>
            <b-col class="d-flex justify-content-between align-items-center">
                <text-header id="atmo-supplier-info" class="atmo-hash-jump-point">Информация о поставщике (исполнителе)</text-header>
            </b-col>
        </b-row>
        <text-row-link compact :label-cols-lg="4" :label-cols-sm="4" label="Наименование" v-model="proposal.supplier.full_name" :router-link="{ name: 'OrganizationShow', params: { id: proposal.supplier.id } }" />
        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="ИНН" v-model="proposal.supplier.inn" />
        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="КПП" v-model="proposal.supplier.kpp" />
        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="ОГРН" v-model="proposal.supplier.ogrn" />
        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Юридический адрес" v-model="proposal.supplier.legal_address" />
        <text-row-single-document v-if="showDocuments" :label-cols-lg="4" :label-cols-sm="4" compact label="Карточка предприятия" v-model="proposal.organization_card" />
        <text-row-raw label="Подтверждение требований к поставщикам" :label-cols-lg="4" :label-cols-sm="4" compact>
            <ul class="fs-14 grey-color my-auto col-form-label">
                <li v-if="proposal.supplier_requirements_confirmed.supplier_reqs_a">
                    <i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил, что соответствует требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ.
                    <ul>
                        <li>Документы, подтверждающие соответствие требованиям:</li>
                        <li v-for="(document, index) in proposal.supplier_requirements_confirmed.supplier_required_documents" :key="index">
                            <ul class="ml-3">
                                <li>
                                    {{ `${index + 1}. ${document.name} - ` }}
                                    <a class="fs-14 atmo-button-link" :href="$getAttachmentDownloadLink(document.storedDocument.id)" target="_blank">{{ document.storedDocument.name }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li v-if="proposal.supplier_requirements_confirmed.supplier_reqs_b">
                    <i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил, что соответствует требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ.
                </li>
                <li v-if="proposal.supplier_requirements_confirmed.supplier_reqs_c">
                    <i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил, что соответствует требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ.
                </li>
                <li v-if="proposal.supplier_requirements_confirmed.supplier_reqs_sonko"><i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил, что является <abbr title="Социально ориентированная некоммерческая организация">СОНКО</abbr>.</li>
                <li v-if="!!proposal.supplier_requirements_confirmed.additional_requirements && proposal.supplier_requirements_confirmed.additional_requirements.length > 0">
                    <i class="atmo-icon-checkbox"></i>&nbsp;Поставщик подтвердил соответствие дополнительным требованиям приложив следующие документы:
                    <ul>
                        <li v-for="(requirement, index) in proposal.supplier_requirements_confirmed.additional_requirements" :key="index">
                            <ul class="ml-3">
                                <li>
                                    {{ `${index + 1}. ${requirement.description} (Причина: ${requirement.reason}) - ` }}
                                    <a class="fs-14 atmo-button-link" :href="$getAttachmentDownloadLink(requirement.attachment.id)" target="_blank">{{ requirement.attachment.name }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </text-row-raw>
        <text-row-single-document v-if="showDocuments && proposal.commercial_proposal" :label-cols-lg="4" :label-cols-sm="4" compact label="Коммерческое предложение" v-model="proposal.commercial_proposal" />
        <text-row-documents compact label="Дополнительные документы" v-model="proposal.documents" :label-cols-lg="4" :label-cols-sm="4" v-if="showDocuments && proposal.documents.length > 0" />
        <text-row-proposal-specification-table v-if="proposal.show_deliverables" v-model="proposal.deliverables" :without-vat="proposal.without_vat">
            <template #header>
                <span class="fs-14 fw-600" style="padding-left: 5px;">Спецификация принятого предложения:</span>
            </template>
        </text-row-proposal-specification-table>
    </div>
</template>

<script>

import TextRowProposalSpecificationTable from '@/components/proposals/partials/text-row-proposal-specification-table.vue';

export default {
    name: 'fl44-unknown-volume-supplier-info-block',
    components: { TextRowProposalSpecificationTable },
    props: {
        proposal: {
            type: Object,
            required: true
        },
        showDocuments: {
            type: Boolean,
            default: false
        },
        isParticipant: {
            type: Boolean,
            default: false
        }
    }
};
</script>
